module.exports = __webpack_public_path__ + "assets/media/vokrug-5.21a60d31.svg";